import { render, staticRenderFns } from "./FRM_faServicios.vue?vue&type=template&id=6a9da1ac&"
import script from "./FRM_faServicios.vue?vue&type=script&lang=js&"
export * from "./FRM_faServicios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports